<template>
  <div class="loading">
    <img
      v-if="loading"
      class="busymark"
      src="@/assets/img/loading.gif"
    />
    <div
      v-if="loading"
      class="tip"
    >数据加载中</div>
    <div
      v-if="error && !loading"
      class="tip"
    >{{errorMsg}}</div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMsg: {
      type: String,
      default: '发生错误了，请重新尝试'
    }
  }
}
</script>
<style lang="less" scoped>
@import url('~@/style/variables.less');
.loading {
  width: 100%;
  height: 0.8rem;
  font-size: @subcontent-font;
  color: @sub-color;
  z-index: 100;
  text-align: center;
  padding-top: 2rem;
  .busymark {
    margin: 0 auto;
    height: 0.5rem;
    width: 0.5rem;
  }
  .tip {
    margin-top: 0.3rem;
  }
}
</style>
